export const dispatchCJSCustomEvent = ({
  eventData, eventName, eventContexts = null, version = '1-0-1',
}) => {
  if (window.adsk?.cjs) {
    window.adsk.cjs.trackCjsEvent({
      eventData,
      baseEvent: { event_name: eventName, event_version: version },
      eventContexts: eventContexts || null,
    });
  }
};

export const getCjsCustomEventForTriggerManualLinkClick = (event) => {
  const cjsCustomEvent = {
    data_wat_link_section: event?.link?.linkSection,
    element_content: event?.link?.linkTitle,
  };
  if (event?.eventData?.values?.cssSelector) {
    cjsCustomEvent.element_id = event.eventData.values.cssSelector;
  }
  return cjsCustomEvent;
};

export const getCjsCustomEventForTriggerGenericPageView = (event) => {
  const cjsCustomEvent = {};

  if (event?.tutorialInfo) {
    const { tutorialInfo } = event;
    cjsCustomEvent.action_type = 'content_viewed';
    cjsCustomEvent.content_id = tutorialInfo.id;
    cjsCustomEvent.learn_content_name = tutorialInfo.name;
    cjsCustomEvent.learn_content_type = tutorialInfo.type;

    if (tutorialInfo.alreadyCompleted !== undefined) {
      cjsCustomEvent.completed = typeof tutorialInfo.alreadyCompleted === 'boolean'
        ? tutorialInfo.alreadyCompleted
        : (tutorialInfo.alreadyCompleted === 'true');
    }
  }

  if (event?.curatedListInfo || event?.courseInfo) {
    const curatedInfo = event.curatedListInfo || event.courseInfo;
    cjsCustomEvent.action_type = 'content_viewed';
    cjsCustomEvent.content_id = curatedInfo.id;
    cjsCustomEvent.learn_content_name = curatedInfo.name;
    cjsCustomEvent.learn_content_type = event.curatedListInfo ? 'curated-list' : 'course';

    if (curatedInfo.alreadyCompleted !== undefined) {
      cjsCustomEvent.completed = typeof curatedInfo.alreadyCompleted === 'boolean'
        ? curatedInfo.alreadyCompleted
        : (curatedInfo.alreadyCompleted === 'true');
    }
  }

  return cjsCustomEvent;
};

export const getCjsLinkClickEventForSearchResult = ({ analyticsArea, href }) => {
  const cjsCustomEvent = {};

  cjsCustomEvent.element_type = 'link';
  cjsCustomEvent.target_url = href;
  cjsCustomEvent.data_wat_loc = analyticsArea;
  cjsCustomEvent.data_wat_val = 'search-result';

  return cjsCustomEvent;
};

export const getCjsLearnOneEventForSearchResult = ({ data }) => {
  const cjsCustomEvent = {};

  cjsCustomEvent.action_type = 'internal_search';
  cjsCustomEvent.content_id = data?.id;
  cjsCustomEvent.learn_content_name = data?.title;
  cjsCustomEvent.learn_content_type = data?.type || 'search-result';

  return cjsCustomEvent;
};

const mapSearchFilters = (result) => {
  const searchFilter = {};

  const processFilters = (filters) => {
    filters.forEach((filter) => {
      const selectedSelections = filter.selections?.filter((selection) => selection.selected) || [];
      if (selectedSelections.length > 0) {
        if (filter.label === 'Product') {
          searchFilter.product_name = selectedSelections[0].text;
        } else if (filter.label === 'Version') {
          searchFilter.version = selectedSelections[0].text;
        } else if (filter.label === 'Category') {
          searchFilter.category = selectedSelections[0].text;
        } else if (filter.label === 'Type') {
          searchFilter.type = selectedSelections.map((s) => s.text);
        } else if (filter.label === 'Sort By') {
          searchFilter.sort_by = selectedSelections[0].text;
        }
      }
    });
  };

  if (result?.filterGroups) {
    result.filterGroups.forEach((fg) => {
      if (fg.filters) {
        processFilters(fg.filters);
      }
    });
  }

  if (result?.filters) {
    processFilters(result.filters);
  }

  return Object.keys(searchFilter).length > 0 ? searchFilter : undefined;
};

export const getCjsSearchEvent = ({ result, actionType = 'search_initiated' }) => {
  const cjsCustomEvent = {
    action_type: actionType,
    input_text: result?.term || '',
    total_result_count: result?.totalResults || 0,
  };

  const searchFilter = mapSearchFilters(result);
  if (searchFilter) {
    cjsCustomEvent.search_filter = searchFilter;
  }

  return cjsCustomEvent;
};

export const getCjsLearnOneEventForCourseStatusChange = ({ courseData, status, alreadyCompleted }) => {
  const cjsCustomEvent = {};

  cjsCustomEvent.action_type = status;
  cjsCustomEvent.content_id = courseData?.id;
  cjsCustomEvent.learn_content_name = courseData?.title;
  cjsCustomEvent.learn_content_type = 'course';
  cjsCustomEvent.status = status;

  if (courseData?.meta?.products) {
    cjsCustomEvent.product_line_code = courseData.meta.products.map((prod) => prod.guid);
  }

  if (courseData?.meta?.discipline) {
    cjsCustomEvent.learn_content_associated_roles = [courseData.meta.discipline];
  }

  if (alreadyCompleted !== undefined) {
    // Convert to boolean - handle both boolean and string inputs for backward compatibility
    cjsCustomEvent.completed = typeof alreadyCompleted === 'boolean'
      ? alreadyCompleted
      : (alreadyCompleted === 'true');
  }

  return cjsCustomEvent;
};

export const getCjsLearnOneEventForModuleStatusChange = ({
  moduleId, moduleData, courseData, status, alreadyCompleted,
}) => {
  const cjsCustomEvent = {};

  cjsCustomEvent.action_type = status;
  cjsCustomEvent.content_id = moduleId;
  cjsCustomEvent.learn_content_type = 'module';
  cjsCustomEvent.status = status;

  if (moduleData) {
    cjsCustomEvent.learn_content_name = moduleData.title;
    cjsCustomEvent.learn_content_step = moduleData.step || 1;
  } else if (courseData) {
    const module = courseData.tutorials?.find((t) => t.id === moduleId);
    if (module) {
      cjsCustomEvent.learn_content_name = module.title;
      cjsCustomEvent.learn_content_step = courseData.tutorials.findIndex((t) => t.id === moduleId) + 1;
    }
  }

  if (courseData?.meta?.products) {
    cjsCustomEvent.product_line_code = courseData.meta.products.map((prod) => prod.guid);
  }

  if (courseData?.meta?.discipline) {
    cjsCustomEvent.learn_content_associated_roles = [courseData.meta.discipline];
  }

  if (alreadyCompleted !== undefined) {
    // Convert to boolean - handle both boolean and string inputs for backward compatibility
    cjsCustomEvent.completed = typeof alreadyCompleted === 'boolean'
      ? alreadyCompleted
      : (alreadyCompleted === 'true');
  }

  return cjsCustomEvent;
};

export const getCjsErrorContextForErrorBanner = ({
  errorLocation, errorType, errorCode, errorReason, errorMessage,
}) => {
  // Map errorType to valid enum values
  const getErrorCategory = (type) => {
    const categoryMap = {
      network: 'NETWORK',
      api: 'API',
      javascript: 'JAVASCRIPT',
      validation: 'VALIDATION',
      business: 'BUSINESS',
      system: 'SYSTEM',
    };
    return categoryMap[type?.toLowerCase()] || 'SYSTEM';
  };

  const errorContext = {
    type: 'error_context',
    version: '1-0-0',
    data: {
      errors: [{
        error_code: errorCode || 'UNKNOWN_ERROR',
        error_message: errorMessage || errorReason || 'Unknown error occurred',
        error_category: getErrorCategory(errorType),
        asset_reference: {
          asset_type: 'javascript_module',
          asset_name: errorLocation || 'unknown',
          asset_endpoint: 'triggerErrorBanner',
        },
        error_severity: 'MEDIUM',
        error_timestamp: new Date().toISOString(),
        retry_count: 0,
      }],
    },
  };

  return errorContext;
};

export const getCjsLinkClickEventForSearchBar = ({ linkTitle = 'search bar' }) => {
  const cjsCustomEvent = {};

  cjsCustomEvent.element_type = 'button';
  cjsCustomEvent.element_content = linkTitle;
  cjsCustomEvent.data_wat_link_section = 'navigation';
  cjsCustomEvent.data_wat_loc = 'search_bar';
  cjsCustomEvent.data_wat_val = `${linkTitle.toLowerCase().replace(/\s+/g, '_')}_click`;

  return cjsCustomEvent;
};

export const getCjsNotificationEventForNotificationImpression = ({ notificationType, notificationReason }) => {
  const cjsCustomEvent = {};

  cjsCustomEvent.action_type = 'dismiss';
  cjsCustomEvent.notification_type = notificationType || 'unknown';

  if (notificationType && notificationType !== 'unknown') {
    cjsCustomEvent.available_actions = ['dismiss'];
  }

  if (notificationReason && notificationReason !== 'unknown') {
    cjsCustomEvent.details = [{
      template_name: 'notification_impression',
      alert_id: `NOTIFICATION:${Date.now()}`,
    }];
  }

  return cjsCustomEvent;
};

export const getCjsLearnOneEventForContentImpression = ({
  containerType, containerName, containerLocation, containerSegment, cssSelector,
}) => {
  const cjsCustomEvent = {};

  cjsCustomEvent.element_type = containerType || 'container';
  cjsCustomEvent.element_id = containerName || 'unknown';

  if (cssSelector) {
    cjsCustomEvent.element_id = cssSelector;
  }

  if (containerLocation) {
    cjsCustomEvent.element_location = containerLocation;
  }

  if (containerSegment) {
    // Truncate to maxLength of 2000 as per schema
    cjsCustomEvent.element_content = containerSegment.length > 2000
      ? containerSegment.substring(0, 2000)
      : containerSegment;
  }

  return cjsCustomEvent;
};

export const getCjsLearnOneEventForProblemResult = ({
  courseData, unitId, problemInfo, moduleData, isUnitComplete,
}) => {
  const cjsCustomEvent = {};

  cjsCustomEvent.action_type = 'problem_result';
  cjsCustomEvent.learn_content_type = 'unit';
  cjsCustomEvent.content_id = unitId;

  if (courseData) {
    const unit = courseData.unitLookup?.[unitId];
    if (unit) {
      cjsCustomEvent.learn_content_name = unit.title;
      cjsCustomEvent.learn_content_parent_section = courseData.tutorials?.find((t) => t.id === unit.parentId)?.title;
    }
  } else if (moduleData) {
    const unit = moduleData.unitLookup?.[unitId];
    if (unit) {
      cjsCustomEvent.learn_content_name = unit.title;
    }
  }

  if (problemInfo) {
    cjsCustomEvent.assessment_block_id = problemInfo.blockId;
    cjsCustomEvent.assessment_current_score = problemInfo.currentScore;
    cjsCustomEvent.assessment_total_possible_score = problemInfo.totalPossibleScore;
    cjsCustomEvent.assessment_result = problemInfo.result;
    cjsCustomEvent.assessment_attempts_used = problemInfo.attemptsUsed;
  }

  if (isUnitComplete !== undefined) {
    // Convert to boolean - handle both boolean and string inputs for backward compatibility
    cjsCustomEvent.completed = typeof isUnitComplete === 'boolean'
      ? isUnitComplete
      : (isUnitComplete === 'true');
  }

  if (courseData?.meta?.products) {
    cjsCustomEvent.product_line_code = courseData.meta.products.map((prod) => prod.guid);
  }

  if (courseData?.meta?.discipline) {
    cjsCustomEvent.learn_content_associated_roles = [courseData.meta.discipline];
  }

  return cjsCustomEvent;
};

export const getCjsLearnOneEventForUnitComplete = ({
  courseData, unitId, moduleData, alreadyCompleted,
}) => {
  const cjsCustomEvent = {};

  cjsCustomEvent.action_type = 'unit_complete';
  cjsCustomEvent.learn_content_type = 'unit';
  cjsCustomEvent.content_id = unitId;
  cjsCustomEvent.status = 'complete';

  const outline = courseData || moduleData;
  if (outline?.unitLookup?.[unitId]) {
    const unit = outline.unitLookup[unitId];
    cjsCustomEvent.learn_content_name = unit.title;

    if (courseData) {
      cjsCustomEvent.learn_content_parent_section = courseData.tutorials?.find((t) => t.id === unit.parentId)?.title;
    }
  }

  if (alreadyCompleted !== undefined) {
    // Convert to boolean - handle both boolean and string inputs for backward compatibility
    cjsCustomEvent.completed = typeof alreadyCompleted === 'boolean'
      ? alreadyCompleted
      : (alreadyCompleted === 'true');
  }

  if (courseData?.meta?.products) {
    cjsCustomEvent.product_line_code = courseData.meta.products.map((prod) => prod.guid);
  }

  if (courseData?.meta?.discipline) {
    cjsCustomEvent.learn_content_associated_roles = [courseData.meta.discipline];
  }

  return cjsCustomEvent;
};

export const getCjsLearnOneEventForCoursePageView = ({
  courseData, unitId, isComplete, isUnitComplete,
}) => {
  const cjsCustomEvent = {};

  cjsCustomEvent.action_type = 'content_viewed';
  cjsCustomEvent.learn_content_type = 'course';
  cjsCustomEvent.content_id = courseData.id;
  cjsCustomEvent.learn_content_name = courseData.title;

  if (isComplete !== undefined) {
    // Convert to boolean - handle both boolean and string inputs for backward compatibility
    cjsCustomEvent.completed = typeof isComplete === 'boolean'
      ? isComplete
      : (isComplete === 'true');
  }

  if (unitId && courseData?.unitLookup?.[unitId]) {
    const unit = courseData.unitLookup[unitId];
    cjsCustomEvent.learn_content_parent_section = unit.title;

    if (isUnitComplete !== undefined) {
      cjsCustomEvent.learn_content_step = courseData?.tutorials?.find((t) => t.id === unit.parentId)?.tutorials?.findIndex((u) => u.id === unitId) + 1;
    }
  }

  if (courseData?.meta?.products) {
    cjsCustomEvent.product_line_code = courseData.meta.products.map((prod) => prod.guid);
  }

  if (courseData?.meta?.discipline) {
    cjsCustomEvent.learn_content_associated_roles = [courseData.meta.discipline];
  }

  return cjsCustomEvent;
};

export const getCjsLearnOneEventForModulePageView = ({
  pageName, courseData, moduleData, moduleId, unitId, isUnitComplete,
}) => {
  const cjsCustomEvent = {};

  cjsCustomEvent.action_type = 'content_viewed';
  cjsCustomEvent.learn_content_type = 'module';
  cjsCustomEvent.content_id = moduleId || moduleData?.id;
  cjsCustomEvent.learn_content_name = moduleData?.title || pageName;

  if (courseData && moduleId) {
    const module = courseData.tutorials?.find((t) => t.id === moduleId);
    if (module) {
      cjsCustomEvent.learn_content_name = module.title;
    }
  }

  if (unitId) {
    const outline = courseData || moduleData;
    if (outline?.unitLookup?.[unitId]) {
      const unit = outline.unitLookup[unitId];
      cjsCustomEvent.learn_content_parent_section = unit.title;

      if (isUnitComplete !== undefined) {
        cjsCustomEvent.learn_content_step = courseData?.tutorials?.find((t) => t.id === unit.parentId)?.tutorials?.findIndex((u) => u.id === unitId) + 1;
      }
    }
  }

  if (courseData?.meta?.products) {
    cjsCustomEvent.product_line_code = courseData.meta.products.map((prod) => prod.guid);
  }

  if (courseData?.meta?.discipline) {
    cjsCustomEvent.learn_content_associated_roles = [courseData.meta.discipline];
  }

  return cjsCustomEvent;
};

export const getCjsLearnOneEventForUnitConsume = ({
  courseData, moduleData, unitId, alreadyCompleted,
}) => {
  const cjsCustomEvent = {};

  cjsCustomEvent.action_type = 'unit_consume';
  cjsCustomEvent.learn_content_type = 'unit';
  cjsCustomEvent.content_id = unitId;

  if (courseData && alreadyCompleted !== undefined) {
    // Convert to boolean - handle both boolean and string inputs for backward compatibility
    cjsCustomEvent.completed = typeof alreadyCompleted === 'boolean'
      ? alreadyCompleted
      : (alreadyCompleted === 'true');

    if (courseData?.unitLookup?.[unitId]) {
      const unit = courseData.unitLookup[unitId];
      cjsCustomEvent.learn_content_name = unit.title;
      cjsCustomEvent.learn_content_parent_section = unit.title;

      const module = courseData.tutorials?.find((t) => t.id === unit.parentId);
      if (module) {
        cjsCustomEvent.learn_content_step = module.tutorials?.findIndex((u) => u.id === unitId) + 1;
      }
    }

    if (courseData?.meta?.products) {
      cjsCustomEvent.product_line_code = courseData.meta.products.map((prod) => prod.guid);
    }

    if (courseData?.meta?.discipline) {
      cjsCustomEvent.learn_content_associated_roles = [courseData.meta.discipline];
    }
  }

  if (moduleData) {
    cjsCustomEvent.learn_content_name = moduleData.title;
  }

  return cjsCustomEvent;
};

export const getCjsLearnOneEventForLearningPlanAction = ({
  data, status, actionType, isBookmarked,
}) => {
  const cjsCustomEvent = {};

  cjsCustomEvent.action_type = actionType;
  cjsCustomEvent.content_id = data.id;
  cjsCustomEvent.learn_content_name = data.title;

  let contentType = 'unknown';
  switch (data?.objectType?.toLowerCase().replace(' ', '')) {
  case 'module':
    contentType = data.learningMode === 'courseware' ? 'module' : 'tutorial';
    break;
  case 'course':
    contentType = data.learningMode === 'courseware' ? 'course' : 'curated-list';
    break;
  case 'learningpathway':
    contentType = 'collection';
    break;
  default:
    contentType = 'unknown';
  }
  cjsCustomEvent.learn_content_type = contentType;

  if (data?.meta?.products) {
    cjsCustomEvent.product_line_code = data.meta.products.map((prod) => prod.guid);
  }

  if (data?.meta?.discipline) {
    cjsCustomEvent.learn_content_associated_roles = [data.meta.discipline];
  }

  if (status) {
    cjsCustomEvent.status = status;
  }

  if (actionType === 'learning_plan_bookmark' && isBookmarked !== undefined) {
    cjsCustomEvent.bookmark_action = isBookmarked ? 'remove-from-bookmarks' : 'add-to-bookmarks';
  }

  return cjsCustomEvent;
};

export const getPageContext = (event, pageCategory = null) => {
  const pageContextData = {};

  if (event?.eventData?.values) {
    const { values } = event.eventData;
    if (values.pageName) {
      pageContextData.page_title = values.pageName;
    }
  }

  if (pageCategory) {
    pageContextData.page_category = pageCategory;
  }

  pageContextData.page_url = window.location.href;
  pageContextData.page_urlhost = window.location.hostname;
  pageContextData.page_urlpath = window.location.pathname;
  pageContextData.page_urlport = window.location.port || (window.location.protocol === 'https:' ? '443' : '80');
  pageContextData.page_urlscheme = window.location.protocol.replace(':', '');
  pageContextData.page_referrer = document.referrer;
  pageContextData.page_locale = document.documentElement?.lang || navigator.language || 'en_US';

  if (document.referrer) {
    try {
      const referrerUrl = new URL(document.referrer);
      pageContextData.page_referrer_urlhost = referrerUrl.hostname;
      pageContextData.page_referrer_urlpath = referrerUrl.pathname;
      pageContextData.page_referrer_urlport = referrerUrl.port || (referrerUrl.protocol === 'https:' ? '443' : '80');
      pageContextData.page_referrer_urlscheme = referrerUrl.protocol.replace(':', '');
    } catch (e) {
      // Invalid referrer URL, skip referrer parsing
    }
  }

  return {
    page_context: {
      version: '1-0-0',
      data: pageContextData,
    },
  };
};
